export default "__VITE_ASSET__64a47789__"